import React from 'react'
import classes from './Table.module.scss'

export const Table = ({
  children,
  label,
  className = 'mc-px-4',
}: {
  children: React.ReactNode
  label: string
  className?: string
}) => (
  <div
    aria-label={label}
    role='table'
    className={`${className} ${classes.table}`}
  >
    {children}
  </div>
)
